import * as React from 'react';
import useIsCompactViewport from '@Guidelines/Component/FilterPanel/Hooks/useIsCompactViewport';

export type FilterPanelState = {
	readonly isCompact: boolean;
	readonly isOpen: boolean;
	readonly panelId: string;
	readonly open: () => void;
	readonly close: () => void;
};

/**
 * Behaviour of a collapsible filter panel: compact-viewport detection, open state and the panel id
 * shared by the trigger and the sidebar. The panel closes by itself when the viewport stops being compact.
 */
const useFilterPanel = (): FilterPanelState => {
	const isCompact = useIsCompactViewport();
	const panelId = React.useId();
	const [isOpen, setIsOpen] = React.useState(false);

	React.useEffect(() => {
		if (!isCompact) {
			setIsOpen(false);
		}
	}, [isCompact]);

	const open = React.useCallback(() => {
		setIsOpen(true);
	}, []);

	const close = React.useCallback(() => {
		setIsOpen(false);
	}, []);

	return { isCompact, isOpen, panelId, open, close };
};

export default useFilterPanel;
